export default __webpack_public_path__ + "static/shell_logo-5659c2c362fad997fac0b586a52e269b.png";